import {
  ProfileTemplatesApi,
  type ProfileTemplate,
} from '@up2stay/up2promo-api-client';

import {
  LIST_FETCH_ALL_MAX_PAGES,
  PROFILE_TEMPLATES_PAGE_MAX,
} from '@/core/lib/list-pagination';

export type FetchAllProfileTemplatesQuery = {
  search?: string;
  onlyMine?: boolean;
};

/**
 * Pages `ProfileTemplatesApi.findAll` until a partial page.
 * Required because the API `@Max(50)` rejects larger `limit` values (400).
 */
export async function fetchAllProfileTemplatesPages(
  workspaceId: string,
  query: FetchAllProfileTemplatesQuery = {},
): Promise<ProfileTemplate[]> {
  const byId = new Map<string, ProfileTemplate>();

  for (let page = 1; page <= LIST_FETCH_ALL_MAX_PAGES; page += 1) {
    const response = await ProfileTemplatesApi.findAll({
      path: { workspaceId },
      query: {
        page,
        limit: PROFILE_TEMPLATES_PAGE_MAX,
        ...(query.search ? { search: query.search } : {}),
        ...(query.onlyMine ? { onlyMine: true } : {}),
      },
    });

    const batch = (response.data?.data ?? []) as ProfileTemplate[];
    for (const template of batch) {
      if (template.id) byId.set(template.id, template);
    }

    const hasNext = response.data?.hasNextPage === true;
    if (
      !hasNext ||
      batch.length === 0 ||
      batch.length < PROFILE_TEMPLATES_PAGE_MAX
    ) {
      break;
    }
  }

  return [...byId.values()];
}
